// extracted by mini-css-extract-plugin
module.exports = {"ComponentStack":"App_ComponentStack__10eQa","whiteBackground":"App_whiteBackground__3Nn6C","greenBackground":"App_greenBackground__1ui2E","videoPage":"App_videoPage___nTYr"};